import React from 'react'
import { useTrans } from 'hooks'
import { StrumentoLibro } from 'react-components/atoms/Icons'
import { LibroCard, AttivaContenutoCard, AggiungiContenutoCard } from 'react-components/molecules'

const TabParascolastico = props => {
  const { className = '', items = [] } = props

  const t = useTrans()

  return (
    <div className={`tab-parascolastico ${className ? ` ${className}` : ''}`}>
      <div className="tab-parascolastico__list">
        {items.map(libro => (
          <LibroCard libro={libro} layout="parascolastico" type="parascolastico" />
        ))}
        <AttivaContenutoCard
          title={
            !items.length ? t('Non ci sono contenuti attivi') : t('Attiva nuovi contenuti digitali')
          }
          description={t(
            'Attiva codici in tuo possesso per fruire di tanti contenuti digitali a te deidicati '
          )}
          ctaLabel={t('Attiva codice')}
          ctaLink="/area-personale/libreria"
          className="tab-parascolastico__activate-cta"
        />
        <AggiungiContenutoCard
          icon={<StrumentoLibro />}
          ctaLabel={t('Aggiungi altri libri')}
          ctaLink="/area-personale/libreria"
          className="tab-parascolastico__add-cta"
        />
      </div>
    </div>
  )
}

export default TabParascolastico
